import Flickity from 'flickity';
require('flickity-imagesloaded');

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.slider');

  if (el) {
    const flickity = new Flickity(el, {
      imagesLoaded: true,
      contain: true,
      cellAlign: 'left',
      adaptiveHeight: false,
      watchCSS: true,
      pageDots: false,
      wrapAround: true,
      selectedAttraction: 0.028,
      friction: 0.25,
      prevNextButtons: false,
      autoPlay: true
    });

    document.addEventListener('click', ({ target }) => {
      target.matches('.featured__arrow.featured--next') && flickity.next();
      target.matches('.featured__arrow.arrow--previous') && flickity.previous();
    });
  }
});
